export const stripePublicKey =
  process.env.REACT_APP_ENV === 'prod'
    ? 'pk_test_51NVBrNSFInz4PQvrfOfcdBQmePgpUjyCVi7Xe9MLOuNiAXaCJCr91KJyCbwVR2fh5qeusUEIAZHaK3wC5Vbjlk3X00Iyz3YkQ6'
    : 'pk_test_51NVBrNSFInz4PQvrfOfcdBQmePgpUjyCVi7Xe9MLOuNiAXaCJCr91KJyCbwVR2fh5qeusUEIAZHaK3wC5Vbjlk3X00Iyz3YkQ6';

export const appId = 
    process.env.REACT_APP_ENV === 'prod' 
      ? '2551847beb666d4c' : process.env.REACT_APP_ENV === 'qa' ? '2551859deb59fec1' : '247824eb72b40ea5';

export const authKey = 
      process.env.REACT_APP_ENV === 'prod' 
        ? '8ade555928e2c93340c770033f6ac779aee4b88a' : 
        process.env.REACT_APP_ENV === 'qa' ? 'ac84bcf87627857446193275c032e4e3c9aaa64b' :
          'e2da73dca313163d3bb3fd711cb0da72b2b77cf5';
         
export const captchaKey = '6LcfpqUoAAAAALokYxUjtTv_vEXHJTR22og6JmOw';          

// Shown (in ProviderUnavailableDialog) when an existing patient's primary provider is no longer
// available for online booking - e.g. the provider left the organization but is still on file as
// the patient's primary provider (see ehr-sync-service SelfSchedulingFreeSlotGenerator.getPatientContext).
/**
 * MM-1156: title of the dialog shown when the patient's assigned provider is no longer with
 * MindWeal and the appointment can't be booked online.
 */
export const PROVIDER_UNAVAILABLE_TITLE = 'Unable to Schedule This Appointment';
/**
 * MM-1156: body of the provider-unavailable dialog - points the patient to Secure Chat or the
 * scheduling phone number so staff can assign a new provider and book the appointment.
 */
export const PROVIDER_UNAVAILABLE_MESSAGE =
  'Your assigned provider is no longer with MindWeal. ' +
  'Please contact us via Secure Chat or call 618-310-0085 so we can assign you a new provider ' +
  'and schedule your appointment.';

// Shown (in InPersonLocationRestrictedDialog) when an Illinois-preferred patient tries to combine
// In-person with a Missouri clinic in the self-scheduling filters - that selection is not applied.
export const IN_PERSON_LOCATION_RESTRICTED_TITLE = 'In-person visit not available';
export const IN_PERSON_LOCATION_RESTRICTED_MESSAGE =
  'As an Illinois patient, you can\'t book an in-person appointment at a Missouri location. ' +
  'Please choose an Illinois location, or switch to Virtual to see Missouri providers.';

// Shown in place of the raw DrChrono throttle detail (e.g. "Request was throttled.
// Expected available in 1045.0 seconds.") whenever a scheduling response comes back
// with throttled: true - that message is meaningless to a patient/staff user.
export const SCHEDULING_UNAVAILABLE_MESSAGE =
  'We are unable to book at this moment. Please call us to schedule: (618) 310-0085';

// Self-scheduling booking/reschedule refused before anything was sent to DrChrono because the
// patient's profile could not be loaded (ehr-sync-service errorCode SS_PATIENT_LOOKUP_FAILED) -
// retrying later is the only thing the patient can do.
export const PATIENT_LOOKUP_FAILED_ERROR_CODE = 'SS_PATIENT_LOOKUP_FAILED';
export const PATIENT_LOOKUP_FAILED_MESSAGE = 'Something went wrong. Please try again after some time.';
